import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api, CATEGORY_LABELS } from "../lib/api";
import { ArrowLeft, MapPin, Phone, Clock, Star, Sparkles, Globe } from "lucide-react";
import MapView from "../components/MapView";

export default function PlaceDetail() {
  const { id } = useParams();
  const [place, setPlace] = useState(null);

  useEffect(() => {
    api.get(`/places/${id}`).then(r => setPlace(r.data)).catch(()=>{});
  }, [id]);

  if (!place) return <div className="pt-32 text-center text-[#5C6B55]">Chargement…</div>;

  return (
    <div className="min-h-screen bg-[#FBF9F6]" data-testid="place-detail">
      <div className="pt-24 max-w-6xl mx-auto px-6 pb-16">
        <Link to="/" data-testid="back-home" className="inline-flex items-center gap-2 text-sm font-semibold text-[#5C6B55] hover:text-[#E26D5C] mb-6">
          <ArrowLeft size={16} /> Retour à la carte
        </Link>

        <div className="grid lg:grid-cols-5 gap-8">
          <div className="lg:col-span-3">
            <div className="rounded-3xl overflow-hidden bg-white border border-black/5 shadow-sm">
              {place.image_url ? (
                <img src={place.image_url} alt={place.name} className="w-full h-[400px] object-cover" />
              ) : (
                <div className="h-[400px] bg-[#F3F0EA] flex items-center justify-center"><MapPin size={48} /></div>
              )}
            </div>

            <div className="mt-6">
              <div className="flex items-center gap-3 flex-wrap">
                <span className="uppercase-label text-[#E26D5C]">{CATEGORY_LABELS[place.category]}</span>
                {place.is_promoted && (
                  <span className="text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full bg-gradient-to-r from-[#F4A261] to-[#E26D5C] text-white flex items-center gap-1">
                    <Sparkles size={10} /> Sponsorisé
                  </span>
                )}
              </div>
              <h1 className="font-display font-black text-4xl lg:text-5xl text-[#2C3627] tracking-tighter mt-2">
                {place.name}
              </h1>
              <div className="flex items-center gap-3 mt-3">
                <div className="flex items-center gap-1 font-semibold">
                  <Star size={16} className="fill-[#F4A261] text-[#F4A261]" />
                  {place.rating?.toFixed(1)}
                </div>
                <span className="text-[#5C6B55]">·</span>
                <span className="text-[#5C6B55]">{place.city}</span>
              </div>
              <p className="mt-6 text-[#2C3627] leading-relaxed">{place.description}</p>
            </div>
          </div>

          <div className="lg:col-span-2 space-y-4">
            <div className="rounded-3xl bg-white border border-black/5 shadow-sm p-6">
              <div className="uppercase-label text-[#5C6B55]">Informations</div>
              <div className="mt-4 space-y-3 text-sm">
                <div className="flex gap-3"><MapPin size={16} className="text-[#E26D5C] mt-0.5" /><span>{place.address}</span></div>
                {place.phone && <div className="flex gap-3"><Phone size={16} className="text-[#E26D5C] mt-0.5" /><a href={`tel:${place.phone}`} className="hover:underline">{place.phone}</a></div>}
                {place.hours && <div className="flex gap-3"><Clock size={16} className="text-[#E26D5C] mt-0.5" /><span>{place.hours}</span></div>}
                {place.website && <div className="flex gap-3"><Globe size={16} className="text-[#E26D5C] mt-0.5" /><a href={place.website} className="hover:underline">{place.website}</a></div>}
              </div>
            </div>
            <div className="rounded-3xl overflow-hidden h-[300px] border border-black/5">
              <MapView places={[place]} focused={place} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
